import { useTranslation } from "react-i18next";

import Modal from "../../../components/base/Modal";
import { Button } from "../../../components/ui";

export interface UnsavedConfigModalProps {
  onSaveAndExit: () => void;
  onDiscard: () => void;
  onCancel: () => void;
}

export default function UnsavedConfigModal({
  onSaveAndExit,
  onDiscard,
  onCancel,
}: UnsavedConfigModalProps) {
  const { t } = useTranslation("common");

  return (
    <Modal
      title={t("monitoreoIa.config.unsavedModal.title")}
      onClose={onCancel}
      width="w-full max-w-md"
      content={
        <div className="space-y-5">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-warning/30 bg-warning/10">
              <i className="ri-error-warning-line text-lg text-warning" />
            </span>
            <p className="text-[13px] leading-relaxed text-content-secondary">
              {t("monitoreoIa.config.unsavedModal.description")}
            </p>
          </div>

          <div className="space-y-2.5">
            <Button
              fullWidth
              shape="pill"
              onClick={onSaveAndExit}
              icon={<i className="ri-save-line" />}
            >
              {t("monitoreoIa.config.unsavedModal.saveAndExit")}
            </Button>
            <Button
              variant="secondary"
              fullWidth
              shape="pill"
              onClick={onDiscard}
              icon={<i className="ri-close-circle-line" />}
            >
              {t("monitoreoIa.config.unsavedModal.discard")}
            </Button>
            <Button variant="ghost" fullWidth shape="pill" onClick={onCancel}>
              {t("monitoreoIa.config.unsavedModal.cancel")}
            </Button>
          </div>
        </div>
      }
    />
  );
}
